import { Service, Token } from 'typedi';
import { Lock } from '../utils/lockUtil';
import { BaseModuleLoader } from '../../loaders/BaseModuleLoader';
import { ILogout } from './models';

const moduleLock = new Lock();

export const LogoutToken = new Token<ILogout>('Logout');

@Service()
export class LogoutLoader extends BaseModuleLoader<ILogout> {
    constructor() {
        super('LogoutLoader');
    }

    protected _createModuleInstance = async (): Promise<ILogout> => {
        const module = await import(
            /* webpackChunkName: "logout/logout" */
            './logout'
        );
        return new module.Logout();
    };

    // Optionally, you can implement _canUse if there is a brand or feature check. For now, always true.
    protected override _canUse: () => Promise<boolean> = async () => {
        return true;
    };

    protected override _getModuleLock = (): Lock => moduleLock;
    protected override _getToken = (): Token<ILogout> => LogoutToken;
}
